import O1HD from "../../../../engines/gameEngine";
import getOneBundle, { BUNDLE_SMALL_NAME, getOneBundleByInstant, getOneBundleOnePrefab } from "../../BundleResourceConfig";
import { getOneNormalEventNewById } from "../../config/normalEvent_NewConfig";
import { getOneChitAryById } from "../../config/WeChatChitChatConfig";
import getPeopleMap, { getOnePeopleById } from "../../config/WeChatPeopleConfig";
import { getOneWeChatTriggerTimeLinkById, startLinkId } from "../../config/WeChatTriggerTimeLinkConfig";
import { NormalEvent_New } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import { WeChatPeople } from "../../manager/WeChatConst";
import normalMode from "../../normalMode";
import WeChatFrame from "../weChat/WeChatFrame";

const {ccclass, property} = cc._decorator;

@ccclass
export default class normalChatEvent_New extends cc.Component {

    @property({type:cc.Label,displayName:"描述文本"})
    lb_Dec:cc.Label = null;

    @property({type:cc.Node,displayName:"center节点"})
    centerNode:cc.Node = null;

    // @property({type:cc.Prefab,displayName:"chatFramePrefab"})
    // chatFramePrefab:cc.Prefab = null;

    @property({type:cc.Sprite,displayName:"头像节点"})
    headSp:cc.Sprite = null;

    eventData:NormalEvent_New = null;

    isStart:boolean = true;

    startData:NormalEvent_New = <NormalEvent_New>{};

    gameLayer:normalMode = null;

    complete ?: ()=>void;

    bindEvent(id:string | number,gameLayer:normalMode,complete?:()=>void){
        this.eventData = <NormalEvent_New>{}
        let event = getOneNormalEventNewById(id);
        for(let k in event){
            let data = event[k];
            if(data instanceof Array){
                this.eventData[k] = data.concat();
                if(this.isStart){
                    this.startData[k] = data.concat();
                }
            }else{
                this.eventData[k] = data;
                if(this.isStart){
                    this.startData[k] = data;
                }
            }
        }
        if(this.isStart){
            this.isStart = false;
        }
        this.gameLayer = gameLayer;
        this.complete = complete;
        this.loadEvent();
    }

    loadEvent(){
        let explain = this.eventData.eventExplain;
        this.lb_Dec.string = explain;

        let people = getPeopleMap()[this.eventData.peopleId];
        let headUrl = people.headUrl;

        getOneBundle(BUNDLE_SMALL_NAME.WeChatGameBundle).then((bundle:cc.AssetManager.Bundle)=>{
            bundle.load(headUrl,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                if(err){
                    console.log(err);
                }else{
                    this.headSp.getComponent(cc.Sprite).spriteFrame = asset;
                }
            });
        });


    }

    async onClick(){
        let param = this.eventData.eventChooses[0].param;
        let coin = param["coin"];

        let add:string = param["addEvent"];
        if(add!=null){
            this.gameLayer.gameManager.getGameData().ariseEvent.push(this.startData.id);
            this.gameLayer.gameManager.writeGameData();
        }


        if(coin!=null){
            O1HD.getServices().userSrv.setCoins(coin,true,this.centerNode);
        }

        let weChatLink = param["WeChatLink"];
        if(weChatLink!=null){
            
            let isTrue = this.gameLayer.gameManager.addOneWeChatTriggerLink(weChatLink);
            if(!isTrue){
                this.closeThis();
                return;
            }

            let link = getOneWeChatTriggerTimeLinkById(weChatLink);

            let chitChat = getOneChitAryById(link.link[0].id);

            // this.gameLayer.onBtnOpenPrefab(null,"weChat");

            let people = this.gameLayer.gameManager.weChatManager.getOnePeopleById(chitChat.people);
            let chatFramePrefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.WeChatGameBundle,"weChat/prefab/WeChatFrame");
            let chitChatQueue = people.peopleChatLinkQueue;
            let chatFrame = cc.instantiate(chatFramePrefab);
            let cs = chatFrame.getComponent(WeChatFrame);
            let isStart:boolean = weChatLink == startLinkId;
            if(isStart){
                // NormalGameManager._instance.driftBattleManager.registerStartEvent();
            }
            if(chitChatQueue.length >0){    
                // let chitChat = getOneChitAryById(chitChatQueue[0]);
                let fun = ()=>{
                    if(isStart){
                        // this.gameLayer.openPlot();
                    }
                    this.closeThis();
                }
                cs.bindData(chitChatQueue[0],[],people,fun,isStart);
            }
            O1HD.Canvas().addChild(chatFrame);

        }

        // ();

    }

    closeThis(complete?:()=>void){
        if(this.gameLayer.gameManager.getNodeStr().length < 1){
            this.gameLayer.gameManager.openOneNewEvent();
        }else{
            this.gameLayer.canShowFlag = true;
        }
        complete && complete();
        this.node.destroy();
        this.node.removeFromParent();
    }

    update(dt: number): void {
        NormalGameManager._instance.pauseTimer();    
    }

    onDisable(): void {
        NormalGameManager._instance.resumeTimer();    
    }

}
